export const generateColumnId = (cellKey: string, prefix: string): string => `${prefix}.${cellKey}`;
